import { GeneratedBizBase } from '../GeneratedBizBase';


import { Response } from '../../../src_server/response/Response';export class ZipCodeService extends GeneratedBizBase{
  async zipCode(zip_code: string): Promise<Response<any>> {
    return super.restCall<Response<any>>('post', '/v1/ZipCodeService/zipCode', arguments);
  }
}
